import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-5xl font-semibold text-center text-gray-800 mb-6">Terms and Conditions</h1>
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-3xl font-semibold text-gray-800 mb-4">Introduction</h2>
          <p className="text-gray-700">
            Welcome to Taxica! By using our services, you agree to the following terms and conditions. Please read them carefully.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1. User Responsibilities</h2>
          <p className="text-gray-700">
            You are responsible for the accuracy of the information you provide and for maintaining the confidentiality of your account.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">2. Services Provided</h2>
          <p className="text-gray-700">
            Taxica provides taxi services to users based on the availability of drivers in your area.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">3. Payment Terms</h2>
          <p className="text-gray-700">
            All payments must be made via our secure payment gateway. Payments are due upon booking, and any cancellations may incur a fee.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4. Privacy and Data Protection</h2>
          <p className="text-gray-700">
            We take your privacy seriously. Please refer to our Privacy Policy for more information on how we handle your personal data.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">5. Limitation of Liability</h2>
          <p className="text-gray-700">
            Taxica is not liable for any damages or losses resulting from the use of our services, beyond the scope of local laws.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">6. Changes to Terms</h2>
          <p className="text-gray-700">
            We reserve the right to change these terms at any time. Please check this page regularly for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
